import { type Action, action, thunk, type Thunk } from 'easy-peasy'

import type { FMPStoreModel } from '@strata-monorepo/find-my-plan/lib/types'
import type { EnrichCustomerResponse } from '@strata-monorepo/shared-types'
import enrichCustomerData from '../../utils/enrichCustomerData'
import type { CohesionGlobal } from '@strata-monorepo/shared-types'
import type { Address } from '@strata-monorepo/shared-ui/types/Address'

export interface EnrichCustomerModel {
  enrichCustomerResponse: EnrichCustomerResponse | null
  enrichCustomerLoading: boolean

  setEnrichCustomerResponse: Action<EnrichCustomerModel, EnrichCustomerResponse>
  setEnrichCustomerLoading: Action<EnrichCustomerModel, boolean>

  fetchEnrichCustomerData: Thunk<
    EnrichCustomerModel,
    {
      CohesionGlobal: CohesionGlobal
      address: Address
    },
    null,
    FMPStoreModel,
    Promise<EnrichCustomerResponse | null>
  >
}

export const enrichCustomerModel = (): EnrichCustomerModel => ({
  enrichCustomerResponse: null,
  enrichCustomerLoading: false,

  setEnrichCustomerResponse: action((state, response) => {
    state.enrichCustomerResponse = response
  }),

  setEnrichCustomerLoading: action((state, loading) => {
    state.enrichCustomerLoading = loading
  }),

  fetchEnrichCustomerData: thunk(
    async (actions, request, {}): Promise<EnrichCustomerResponse | null> => {
      try {
        actions.setEnrichCustomerLoading(true)
        const response = await enrichCustomerData(request.CohesionGlobal, request.address)

        actions.setEnrichCustomerResponse(response)
        return response
      } catch {
        return null
      } finally {
        actions.setEnrichCustomerLoading(false)
      }
    },
  ),
})
